import React from "react";
import "./ExperienceCard.scss";

export default function ExperienceCard({cardInfo, isDark, index}) {
  return (
    <article className={isDark ? "experience-card experience-card-dark" : "experience-card"}>
      <div className="experience-index">
        {String(index + 1).padStart(2, "0")}
      </div>

      <div className="experience-content">
        <div className="experience-topline">
          <span className="experience-date">{cardInfo.date}</span>
          {cardInfo.companylogo ? (
            <img
              className="experience-logo"
              src={cardInfo.companylogo}
              alt={cardInfo.company}
            />
          ) : null}
        </div>

        <h3 className="experience-text-role">{cardInfo.role}</h3>
        <p className="experience-company">{cardInfo.company}</p>
        <p className="experience-text-desc">{cardInfo.desc}</p>

        {cardInfo.descBullets && (
          <ul className="experience-bullets">
            {cardInfo.descBullets.map((item, i) => (
              <li key={i}>{item}</li>
            ))}
          </ul>
        )}
      </div>
    </article>
  );
}
